module.exports = __webpack_public_path__ + "static/assets/f502294eb9076d136031153d57665599.svg";